import clientLogos from '../../../images/client-logos.svg';
import { getBrandConfig } from '../../../shared/branding/brand-config';

/**
 * Returns the report logo URLs for the given brand.
 * Falls back to Revelio defaults when `clientName` is not provided.
 *
 * The `clientLogos` SVG is always the Revelio client logos composite —
 * client brands can provide their own `reportLogo` for the cover page.
 */
export function getReportBrandLogos(clientName?: string | null) {
  const brand = getBrandConfig(clientName);

  return {
    logoImage: brand.logos.reportLogo,
    clientLogos,
  };
}
